// extracted by mini-css-extract-plugin
export var highlightFade = "_3a-4";
export var highlighted = "_3a-3";
export var table = "_3a-1";
export var tableContainer = "_3a-0";
export var totalsRow = "_3a-2";